import { storeToRefs } from 'pinia';

// Boots the CometChat session at app level and keeps the sidebar unread badge (spec §8.1
// AC9) in sync. Called once from the authenticated shell (`layouts/base.vue`), so the
// session and the count are live on every authenticated page — not only inside Messages.
//
// `useCometChat().setup()` is idempotent and no-ops for tenants without a
// `cometchatAuthToken`, so the heavy chat SDK only loads for pros who actually have a
// marketplace inbox. The Messages page still calls `setup()` itself (also idempotent),
// so nothing regresses if it is opened directly.
export default function useMessagesUnreadInit(): void {
    const cometchat = useCometChat();
    const unread = useMessagesUnreadStore();
    const { tenant } = storeToRefs(useAuthStore());

    onMounted(() => {
        useWhenTenantReady(() => cometchat.setup());
    });

    // Start / stop the unread tracker as the session comes and goes.
    watch(
        cometchat.status,
        (status) => {
            if (status === 'ready') unread.startTracking();
            else unread.stopTracking();
        },
        { immediate: true }
    );

    // Rebuild the session on tenant switch (its cometchatAuthToken differs).
    watch(
        () => tenant.value?.getId(),
        () => cometchat.setup()
    );

    onBeforeUnmount(() => unread.stopTracking());
}
